import React, { useState } from "react";
import "./ProtectedRoute.scss";
import LockPng from './images/lock.png';

export default function ProtectedRoute({ children }) {
  const [authorized, setAuthorized] = useState(false);
  const [input, setInput] = useState("");

  const PASSWORD = "work2026";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === PASSWORD) {
      setAuthorized(true);
    } else {
      alert("Incorrect password");
    }
  };

  if (!authorized) {
    return (
      <div className="password-wrapper">
      <img src={LockPng}/>

        <form className="password-box" onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Password"
            autoFocus
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="password-input"
          />
          <button type="submit" className="password-submit">
            →
          </button>
        </form>
      </div>
    );
  }

  return children;
}